"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
require("core-js");
require("regenerator-runtime/runtime");
var reactn_1 = tslib_1.__importStar(require("reactn"));
var ReactDOM = tslib_1.__importStar(require("react-dom"));
var axios_1 = tslib_1.__importDefault(require("axios"));
var csv2json_1 = require("./util/csv2json");
var question_1 = require("./components/question");
var styles = require('./styles/app.scss');
var Q_URL = "./q.csv";
var App = function () {
    var _a = reactn_1.useGlobal(), qaList = _a[0], setQaList = _a[1];
    var _b = reactn_1.useState(false), initialized = _b[0], setInitialized = _b[1];
    reactn_1.useEffect(function () {
        if (initialized) {
            document.title = "initialized";
        }
    }, [initialized]);
    // load data
    reactn_1.useEffect(function () {
        axios_1.default.get(Q_URL).then(function (res) {
            setQaList(csv2json_1.csv2json(res.data));
            setInitialized(true);
        });
    }, [qaList]);
    var renderQ = Object.values(qaList).map(function (q, index) {
        if (index === 0)
            return null;
        return (reactn_1.default.createElement("li", { key: q }, q[2]));
    });
    var showNumber = 1;
    return (reactn_1.default.createElement("div", { className: styles.app },
        reactn_1.default.createElement("h5", null, "Questions"),
        reactn_1.default.createElement("ul", null, renderQ),
        reactn_1.default.createElement("hr", null),
        reactn_1.default.createElement(question_1.Question, { show: showNumber })));
};
//////
ReactDOM.render(reactn_1.default.createElement(reactn_1.default.Fragment, null,
    reactn_1.default.createElement(App, null)), document.getElementById("app"));
